import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import ProductionImg from './img/Production.png'

export default class Production extends Component {
  render() {
    return (
      <div className="main-window">
      <div className="main-window-title">生产定制</div>
      <div className="main-window-content">用户选择产品后可进行生产定制操作：</div>
      <div className="main-window-content">1、点击生产定制按钮，弹出生产操作弹窗</div>
      <div className="main-window-content">2、确认选择的数据产品，确认后进行下一步</div>
      <div className="main-window-content">3、选择需要的算法，确认后进行下一步</div>
      <div className="main-window-content">4、填写对应算法的参数数据，点击确定，生成生产订单</div>
      <img src={ProductionImg} className="main-window-img"></img>
    </div>
    )
  }
}
